export default "__VITE_ASSET__Dz5L9hDZ__"